import styled from 'styled-components';
import { Stack } from '@atlas-frontend/sdk';

export const ContentWrapper = styled(Stack)`
  width: 100%;
  height: 100%;
  align-self: center;
`;

export const DescriptionsWrapper = styled.div`
  .ant-descriptions-item {
    white-space: pre-line;
  }
`;
